import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalVariables } from '../../../global-variables';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RetailStoreService {
  private url = GlobalVariables.appURL;

  constructor(private _httpClient: HttpClient) { }

  public list(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'stores/list', data);
  }

  public detail(id: any): Observable<any> {
    return this._httpClient.get(this.url + 'stores/' + id);
  }

  public delete(id: any): Observable<any> {
    return this._httpClient.delete(this.url + 'stores/' + id);
  }

  public create_business_user(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'business/user/stores', data);
  }

  public create(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'stores', data);
  }

  public update(data: any): Observable<any> {
    return this._httpClient.patch(this.url + 'stores/' + data.id, data);
  }

  
  public getLinkedStores(email: any,businessStoreId:any): Observable<any> {
    return this._httpClient.get(this.url + 'user/stores?email=' + email + ' && businessStoreId=' + businessStoreId);
  }

  public sendStoresLink(data: any): Observable<any> {
    return this._httpClient.post(this.url + 'business/stores', data);
  }

  public generate_qrcode(): Observable<any> {
    return this._httpClient.get(this.url + 'store-users/generate-qr-code');
  }

  public new_retailer_store_status(storeId: any): Observable<any> {
    return this._httpClient.post(this.url + 'new-retailer-store-status/' + storeId, {});
  }

  getIndustryVerticals(): Observable<any> {
    return this._httpClient.get(this.url + 'constants/constantType/IndustryVertical');
  }
  
}

